// @helpers
const apiURLBuilder = require('../core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

// @constants
const {
    BROKER_ALL_INDEXES_PAGE_SIZE,
    BROKER_ALL_INDEXES_EXCHANGE_ID,
    BROKER_ALL_INDEXES_SPC_SYMBOL,
    BROKER_TICKER_SCREEN
} = require('constants/index');

const {
    BROKER_ALL_INDEXES_FETCHING,
    BROKER_ALL_INDEXES_FETCHING_SUCCESS,
    BROKER_ALL_INDEXES_FETCHING_FAILURE
} = require('constants/actionTypes');

const successFetch = (data) => ({
    type: BROKER_ALL_INDEXES_FETCHING_SUCCESS,
    payload: {
        data
    }
});

const failureFetch = (error) => ({
    type: BROKER_ALL_INDEXES_FETCHING_FAILURE,
    payload: {
        error
    }
});

const fetchIndexes = () => (dispatch) => {
    dispatch({
        type: BROKER_ALL_INDEXES_FETCHING,
        payload: {}
    });

    const url = apiURLBuilder.getURL('exchangeIndexes');
    const request = {
        pageNum: 0,
        pageSize: BROKER_ALL_INDEXES_PAGE_SIZE,
        exchangeId: BROKER_ALL_INDEXES_EXCHANGE_ID,
        spcSymbol: BROKER_ALL_INDEXES_SPC_SYMBOL,
        screen: BROKER_TICKER_SCREEN
    };

    return APIGet(dispatch, url, { query: request }).then(
        (response) => dispatch(successFetch(response)),
        (error) => dispatch(failureFetch(error))
    );
};

module.exports = {
    fetchIndexes
};
